import { useState } from 'react';
import { api } from '../services/api';
import { useQuery } from 'react-query';
import { debounce } from '../utils/debounce';

async function searchCep(cep) {
  const response = await api.get(`/site/v2/pedido/busca-endereco-cliente/${cep}`);

  return response.data[0];
}

export const useEndereco = () => {
  const [cep, setCep] = useState('');

  function handleCep(cep) {
    cep = cep.replace(/\D/g, '');

    debounce(setCep(cep), 300);
  }

  const { data: endereco, isLoading } = useQuery({
    queryKey: ['endereco', cep],
    queryFn: () => searchCep(cep),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10,
    enabled: !!cep && cep.length === 8
  });

  return {
    endereco,
    isLoading,
    handleCep
  };
};
